export default {
  partner:
    'Fastsæt dit Stripe-behandlingsgebyr, eller bekræft 0 % margin. Indtil da kan dine restauranter på Stripe ikke gå live.',
  partner_live_one:
    'Fastsæt dit Stripe-behandlingsgebyr, eller bekræft 0 % margin. Indtil da kan dine restauranter på Stripe ikke gå live, og din live restaurant modtager ingen onlinebetalinger.',
  partner_live_other:
    'Fastsæt dit Stripe-behandlingsgebyr, eller bekræft 0 % margin. Indtil da kan dine restauranter på Stripe ikke gå live, og dine {{count}} live restauranter modtager ingen onlinebetalinger.',
  restaurant:
    'Onlinebetalinger er sat på pause, indtil din partner har fastsat sit behandlingsgebyr. Kontantbetalinger fungerer stadig.',
  cta: 'Fastsæt behandlingsgebyr',
};
